"use strict";

require("../../style/default.less");

require("../../grid/style");